module.exports = __webpack_public_path__ + "static/result-7931cff4dd4ae489f3ac9d3b8de38767.svg";